import Vue from 'vue'
import Router from 'vue-router'
import Index from '../components/Index'
import recycle from '../view/recycle'
import deposit from '../view/deposit'
import aboutUs from '../view/aboutUs'
import pawnshopNews from '../view/pawnshopNews'
import pawnNewsDetail from '../view/pawnNewsDetail'
import gold from '../view/gold'
import cooperate from '../view/cooperate'
import moblieHome from '@/view/moblieHome'   // 手机端H5

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Index',
            component: Index
        },
		{
		    path: '/recycle',  // 回收
		    name: 'recycle',
		    component: recycle,
		    props: route => ({ query: route.query.q })
		},
		{
		    path: '/deposit',  // 寄存
		    name: 'deposit',
		    component: deposit,
		    props: route => ({ query: route.query.q })
		},
		{
		    path: '/aboutUs',  // 关于我们
		    name: 'aboutUs',
		    component: aboutUs,
		    props: route => ({ query: route.query.q })
		},
		{
		    path: '/gold',  // 今日金价
		    name: 'gold',
		    component: gold,
		    props: route => ({ query: route.query.q })
		},
		{
		    path: '/cooperate',  // 商户合作
		    name: 'cooperate',
		    component: cooperate,
		    props: route => ({ query: route.query.q })
		},
		{
		    path: '/pawnshopNews',  // 当铺资讯
		    name: 'pawnshopNews',
		    component: pawnshopNews,
		    props: route => ({ query: route.query.q })
		},
		{
		    path: '/pawnNewsDetail',  // 当铺资讯详情
		    name: 'pawnNewsDetail',
		    component: pawnNewsDetail,
		    props: route => ({ query: route.query.q })
		},
		{
		    path: '/moblieHome',  //手机端H5
		    name: 'moblieHome',
		    component: moblieHome,
		    props: route => ({ query: route.query.q })
		},
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js